import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getOverview } from '../actions/Home';
import { latestReleaseNote, setReleaseNoteSeen } from '../actions/EpikBoxes';
import WithUserData from '../HOC/withUserData';
import path from '../Res/Path.png';
import box from '../Res/WBoxes.png';
import fax from '../Res/WFax.png';
import vmail from '../Res/WVoiceMail.png';
import { Container } from 'reactstrap';
import './Home.css';
import { EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import CustomModal from '../components/CustomModal';
import PasswordExpireWarning from '../components/PasswordExpireWarning';
class Home extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.passwordExpiryMessageSeen = sessionStorage.getItem('passwordExpiryMessageSeen') || false;
    props.getOverview(this.token);
    this.state = {
      editorState: {},
      releaseModal: false,
      latestStatus: false,
      passwordExpiryModal: false,
    };
  }
  async componentDidMount() {
    const { user } = this.props;
    if (user.resetPassword) {
      window.location.href = '/profile?resetPassword';
      return;
    }

    if (!this.passwordExpiryMessageSeen && user.passwordExpiryInDays < 15) {
      this.setState(() => {
        return {
          ...this.state,
          passwordExpiryModal: true,
        };
      });

      setImmediate(() => sessionStorage.setItem('passwordExpiryMessageSeen', true));
    }
  }
  componentDidUpdate(prevProps) {
    const { latestRelease } = this.props;
    if (latestRelease !== prevProps.latestRelease) {
      if (Object.keys(latestRelease.releaseNote).length !== 0) {
        const contentBlock = htmlToDraft(latestRelease.releaseNote.htmlText);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          const editorState = EditorState.createWithContent(contentState);
          this.setState({
            editorState,
            releaseModal: true,
            latestStatus: false,
          });
        }
      }
    }
  }
  onCancelRelease = async () => {
    const { setReleaseNoteSeen } = this.props;
    setReleaseNoteSeen(this.token);
    this.setState({ releaseModal: false });
  };

  onPasswordExpiryModalCancel = () => {
    this.setState(() => {
      return {
        ...this.state,
        passwordExpiryModal: false,
      };
    });
  };

  render() {
    const { overview, user } = this.props;
    const { releaseModal, editorState } = this.state;
    return (
      <Container fluid>
        <div className="overviewContainer">
          {/* Commenting the code for future use. */}
          {/* <Link
            to="/calls"
            className="count-card"
            hidden={user.company.companyType === 'manufacturer'}
            id="test-calls-card"
          >
            <div className="count-icon">
              <div className="icon-round">
                <img className="dashboard-card-icon" src={calls} alt="..." />
              </div>
            </div>
            <div className="count-number">
              <h2>{overview.calls && overview.calls.toLocaleString('en-EG')}</h2>
              <div className="count-number-icon">
                <img
                  className="dashboard-card-icon"
                  style={{ width: '45px', marginTop: '10px' }}
                  src={path}
                  alt="..."
                />
              </div>
            </div>
            <p className="count-title">Calls</p>
          </Link> */}

          <Link
            hidden={user.company.companyType === 'manufacturer'}
            to="/legacy-fax"
            className="count-card"
            id="test-fax-card"
          >
            <div className="count-icon">
              <div className="icon-round">
                <img className="dashboard-card-icon" src={fax} alt="..." />
              </div>
            </div>
            <div className="count-number">
              <h2 id="test-calls-value">
                {overview.faxes && overview.faxes.toLocaleString('en-EG')}
              </h2>
              <div className="count-number-icon">
                <img
                  className="dashboard-card-icon"
                  style={{ width: '45px', marginTop: '10px' }}
                  src={path}
                  alt="..."
                />
              </div>
            </div>
            <p className="count-title">Fax</p>
          </Link>

          <Link
            hidden={
              user.role !== 'superAdmin' &&
              user.role !== 'companyGroupAdmin' &&
              user.role !== 'companyGroupManager' &&
              user.role !== 'admin' &&
              user.role !== 'enterpriseAdmin'
            }
            to="/boxes"
            className="count-card"
            id="test-edge-device-card"
          >
            <div className="count-icon">
              <div className="icon-round">
                <img className="dashboard-card-icon" src={box} alt="..." />
              </div>
            </div>
            <div className="count-number">
              <h2 id="test-edge-device-value">
                {overview.epikBoxes && overview.epikBoxes.toLocaleString('en-EG')}
              </h2>
              <div className="count-number-icon">
                <img
                  className="dashboard-card-icon"
                  style={{ width: '45px', marginTop: '10px' }}
                  src={path}
                  alt="..."
                />
              </div>
            </div>
            <p className="count-title">Edge Device</p>
          </Link>

          <Link
            hidden={user.company.companyType === 'manufacturer'}
            to="/vmails"
            className="count-card"
            id="test-vmails-card"
          >
            <div className="count-icon">
              <div className="icon-round">
                <img className="dashboard-card-icon" src={vmail} alt="..." />
              </div>
            </div>
            <div className="count-number">
              <h2 id="test-vmails-value">
                {overview.vmails && overview.vmails.toLocaleString('en-EG')}
              </h2>
              <div className="count-number-icon">
                <img
                  className="dashboard-card-icon"
                  style={{ width: '45px', marginTop: '10px' }}
                  src={path}
                  alt="..."
                />
              </div>
            </div>
            <p className="count-title">Vmails</p>
          </Link>
        </div>
        {Object.keys(editorState).length !== 0 && (
          <CustomModal submitDisplay close isOpen={releaseModal} onCancel={this.onCancelRelease}>
            <Editor toolbarHidden editorState={this.state.editorState} readOnly />
          </CustomModal>
        )}

          
        {/* Uncomment this to enable passwordExpiryModal

        {this.state.passwordExpiryModal && (
          <PasswordExpireWarning
            isOpen={this.state.passwordExpiryModal}
            toggle={this.onPasswordExpiryModalCancel}
            days={user.passwordExpiryInDays}
          />
        )} */}
      </Container>
    );
  }
}

const mapStateToProps = store => ({
  user: store.AppState.user,
  overview: store.AppState.home,
  latestRelease: store.AppState.boxDetails.latestRelease,
});

const mapDispatchToProps = dispatch => {
  return {
    getOverview: token => dispatch(getOverview(token)),
    latestReleaseNote: token => dispatch(latestReleaseNote(token)),
    setReleaseNoteSeen: token => dispatch(setReleaseNoteSeen(token)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Home));
